import { render, staticRenderFns } from "./Regulation21.vue?vue&type=template&id=ff0cab2c&"
import script from "./Regulation21.vue?vue&type=script&lang=ts&"
export * from "./Regulation21.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports